"use client";

import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  IconButton,
  useBreakpointValue,
} from "@chakra-ui/react";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
import Slider from "react-slick";

import filing from "../images/carousel-1.jpg";
import painting from "../images/carousel-2.jpg";
import french from "../images/carousel-3.jpg";

const settings = {
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export default function Carousel() {
  const [slider, setSlider] = React.useState(null);
  const top = useBreakpointValue({ base: "90%", md: "50%" });
  const side = useBreakpointValue({ base: "30%", md: "10px" });

  const cards = [
    {
      image: painting,
      heading: "Beautiful Nail Art",
      text: "Experience the best nail painting services for all occasions.",
      buttonText: "Book Now",
      buttonLink: "#contact",
    },
    {
      image: filing,
      heading: "Expert Nail Filing",
      text: "Get the perfect nail shape with our expert filing services.",
      buttonText: "Book Now",
      buttonLink: "#contact",
    },
    {
      image: french,
      heading: "French Manicure",
      text: "Classic French manicure to give your nails a timeless look.",
      buttonText: "Book Now",
    },
  ];

  return (
    <Box
      position={"relative"}
      height={"800px"}
      width={"full"}
      overflow={"hidden"}
    >
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      {/* Left Icon */}
      <IconButton
        aria-label="left-arrow"
        opacity={"0.2"}
        variant="ghost"
        position="absolute"
        left={side}
        top={top}
        transform={"translate(0%, -50%)"}
        zIndex={2}
        onClick={() => slider?.slickPrev()}
      >
        <BiLeftArrowAlt size="40px" />
      </IconButton>
      {/* Right Icon */}
      <IconButton
        aria-label="right-arrow"
        variant="ghost"
        opacity={"0.2"}
        position="absolute"
        right={side}
        top={top}
        transform={"translate(0%, -50%)"}
        zIndex={2}
        onClick={() => slider?.slickNext()}
      >
        <BiRightArrowAlt size="40px" />
      </IconButton>
      {/* Slider */}
      <Slider {...settings} ref={(slider) => setSlider(slider)}>
        {cards.map((card, index) => (
          <Box
            key={index}
            height={"100vh"}
            position="relative"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundImage={`url(${card.image})`}
          >
            {/* Overlay Content */}
            <Flex
              direction="column"
              align="center"
              justify="center"
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              textAlign="center"
              color={"white"}
              textAnchor="middle"
              //   bg="rgba(251, 231, 239, 0.4)" // Semi-transparent background for text readability
              p={8}
              borderRadius="md"
              maxW="80%"
            >
              <Heading
                fontSize={{ base: "6xl", md: "8xl" }}
                mb={4}
                fontFamily="Sacramento, cursive"
                fontWeight="600"
                textShadow={"2px 2px 4px pink"}
              >
                {card.heading}
              </Heading>
              <Text
                fontSize={{ base: "xl", md: "2xl" }}
                mb={6}
                fontWeight={"300"}
                fontFamily="Playwrite DE SAS, cursive"
              >
                {card.text}
              </Text>
              <Button
                as="a"
                mt={"30px"}
                href="/contact"
                bg={"lightpink"}
                color={"gray"}
                size="lg"
                _hover={{ bg: "pink" }}
              >
                {card.buttonText}
              </Button>
            </Flex>
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
